
import {ImpactScore} from 'src/components';

import './styles.css';

type Props = {
  score?: number
}

export const ImpactScoreExplanation = ({score}: Props) => {
  return (
    <div className="ImpactScoreExplanation">
      <div className="ImpactScoreExplanation__content">
        <div className="ImpactScoreExplanation__first-row">
          <h1>Impact Score</h1>
          {score && (<ImpactScore size={300} score={score} />)}
        </div>
        <div className="ImpactScoreExplanation__second-row">
          <div className="ImpactScoreExplanation__section">
            <h3>What is the CodeLogic Impact Score?</h3>
            <p>During a scan, Codelogic collects information about your application
            to identify complex code and dependencies. We calculate a score
            based on this information to highlight parts of the code that may be
            require refactoring or other remediation.</p>
          </div>
          <div className="ImpactScoreExplanation__section">
            <h3>What items get an Impact Score?</h3>
            <p>Impact Scores are calculated for:</p>
            <ul>
              <li><b>Methods:</b> Code complexity, Instruction count, and Incoming
              relationships</li>
              <li><b>Classes:</b> Method counts and Method Impact Scores</li>
              <li><b>Applications:</b> Method Impact Scores, Class Impact Scores, and
            Class counts</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
